export default "__VITE_ASSET__KeZkLcpI__"